import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import { uaToDeviceType } from '@cian/ui-kit/utils';

import { PageLayout } from '../../components/PageLayout';
import { useLocationChange } from '../../hooks/browserHistory';
import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { TThunkDispatch } from '../../types/redux/thunk';
import { ApplicationContext } from '../../utils/applicationContext';
import { ErrorContainer } from '../ErrorContainer';
import { HeaderContainer } from '../Header';
import { PageMetaContainer } from '../PageMeta';
import { PromoDetailsModalContainer } from '../PromoDetailsModalContainer';
import { SearchResultsContainer } from '../SearchResults';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
  } = context;

  const dispatch = reduxStore.dispatch as TThunkDispatch;

  useLocationChange(dispatch);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={uaToDeviceType(userAgent || undefined)}>
          <Provider store={reduxStore}>
            <PageLayout>
              <PageMetaContainer />
              <HeaderContainer />
              <SearchResultsContainer />
              <PromoDetailsModalContainer />
              <ErrorContainer />
            </PageLayout>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
